import type { SaveGoalTrackerSpec } from "./types";

export interface SaveGoalTrackerDisplayItem {
  id: string;
  title: string;
  description: string;
}

export const normalizeSaveGoalTrackerSpecs = (
  specs: SaveGoalTrackerSpec[] | undefined,
): SaveGoalTrackerDisplayItem[] => {
  if (!Array.isArray(specs)) {
    return [];
  }

  return specs
    .filter(
      (spec): spec is SaveGoalTrackerSpec =>
        Boolean(spec) &&
        typeof spec === "object" &&
        typeof spec.title === "string" &&
        spec.title.trim().length > 0,
    )
    .map((spec, index) => ({
      id: `save-goal-tracker-${index}`,
      title: spec.title.trim(),
      description: spec.description?.trim() || "",
    }));
};
